import React from "react";
import store from "@/store";

const storeContext = React.createContext(store);

export default storeContext;
